import React from 'react';
import { ethers } from 'ethers';
import { useNavigate } from 'react-router-dom';
import { formatUSDT } from '../../utils/format';
import { useXtPrice } from '../../hooks/useXtPrice';

export default function WithdrawCTA({ pending }) {
  const navigate = useNavigate();
  const { xtPrice } = useXtPrice();
  const has = pending && pending.gt(0);

  const pendingXt = pending && xtPrice && xtPrice.gt(0)
    ? pending.mul(ethers.utils.parseUnits('1', 18)).div(xtPrice)
    : ethers.BigNumber.from(0);

  return (
    <div className="withdraw-cta">
      <div className="wc-info">
        <div className="wc-label">
          <span className="money-icon">💰</span>
          <span>Available Rewards</span>
        </div>
        <div className="wc-value">
          {formatUSDT(pendingXt, 4)}
          <span className="cur">XT</span>
        </div>
        <div className="wc-value" style={{ fontSize: '0.65em', opacity: 0.85, marginTop: 4 }}>
          ≈ {formatUSDT(pending)}
          <span className="cur">USDT</span>
        </div>
        <div className="wc-hint">
          {has ? 'Ready to withdraw as XT or USDT' : 'Earn from daily mining and level rewards'}
        </div>
      </div>
      <button className="wc-btn" onClick={() => navigate('/withdraw')} disabled={!has}>
        WITHDRAW →
      </button>
    </div>
  );
}
